import Slider from '../components/Slider';

const defaults = {
  wrapAround: true,
  pageDots: false,
  autoPlay: false,
  adaptiveHeight: true,
  arrowShape: 'M24.5,51.6v-3.2l19.6-19.6l3.2,3.2L31.5,47.8h44.1v4.5H31.5L47.2,68l-3.2,3.2L24.5,51.6z',
  slidesPerGroup: 2,
};

export default class News {
  constructor(element) {
    this.element = element;
    this.settings = defaults;
    this.preprocess();
    this.build();
    this.ready();
  }

  preprocess() {
    const total = Math.ceil(this.slides.length / this.settings.slidesPerGroup);
    const groupings = [];
    let groupID = 0;

    // Create a multi-dimensional array which houses each group array within
    // a groupings array.
    for (let index = 0; index < total; index += 1) {
      groupings.push([]);
    }

    // Place each slide within it's proper group.
    this.slides.forEach((slide, index) => {
      groupings[groupID].push(slide);
      if (index % this.settings.slidesPerGroup === 1) {
        groupID += 1;
      }
    });

    // Loop through each group within the multi-dimensional groupings array
    // to nest slides within a group wrapper element.
    groupings.forEach((group, index) => {
      const slideGroup = document.createElement('div');
      slideGroup.className = 'slide-group';
      this.container.appendChild(slideGroup);
      group.forEach((slide) => {
        slideGroup.appendChild(slide);
      });

      // Add in missing classname when there is only one slide group.
      if (index === 0 && groupings.length === 1) {
        slideGroup.classList.add('is-selected');
      }
    });
  }

  build() {
    this.Slider = new Slider(this.container, this.settings);
  }

  ready() {
    this.element.classList.add('ready');
  }

  get container() {
    return this.element.querySelector('.slider');
  }

  get slides() {
    return this.container.querySelectorAll('.slide');
  }
}
